<div
  class="theme-preview"
  [class.theme-preview--mini]="size() === 'mini'"
  [class.theme-preview--card]="size() === 'card'"
  [class.theme-preview--large]="size() === 'large'"
  [class.theme-preview--login]="variant() === 'login'"
  [class.theme-preview--interactive]="interactive()"
  [ngStyle]="cssVars()"
>
  @if (variant() === 'login') {
    <div class="theme-preview__login-card" aria-hidden="true">
      <span class="theme-preview__login-brand">
        <span class="theme-preview__mark"></span>
        <span>Tourfold</span>
      </span>
      <span class="theme-preview__login-heading">Sign in</span>
      <span class="theme-preview__login-field"></span>
      <span class="theme-preview__login-field"></span>
      <span class="theme-preview__primary-action theme-preview__login-submit">Sign in</span>
      <span class="theme-preview__login-link">Forgot your password?</span>
    </div>
  } @else {
  <aside class="theme-preview__sidebar">
    <div class="theme-preview__sidebar-header">
      <span class="theme-preview__mark"></span>
      @if (showLabels()) {
        <span>Tourfold</span>
      }
    </div>

    <div class="theme-preview__nav" aria-hidden="true">
      @for (item of navItems.slice(0, navLimit()); track item; let i = $index) {
        <div class="theme-preview__nav-item" [class.theme-preview__nav-item--active]="i === 2">
          <span class="theme-preview__nav-icon"></span>
          @if (showLabels()) {
            <span>{{ item }}</span>
          }
        </div>
      }
    </div>
  </aside>

  <main class="theme-preview__main">
    <header class="theme-preview__topbar">
      <span class="theme-preview__topbar-title">Objects</span>
      <span class="theme-preview__topbar-actions">
        <span class="theme-preview__circle theme-preview__circle--outline"></span>
        <span class="theme-preview__avatar">L</span>
      </span>
    </header>

    <section class="theme-preview__content">
      @if (showCatalog()) {
        <div class="theme-preview__tabs" aria-hidden="true">
          @for (tab of tabs; track tab; let i = $index) {
            <span class="theme-preview__tab" [class.theme-preview__tab--active]="i === 0">{{ tab }}</span>
          }
        </div>

        <div class="theme-preview__toolbar">
          <span class="theme-preview__input">Search...</span>
          <span class="theme-preview__toggle"><span class="theme-preview__toggle-knob"></span></span>
          <span class="theme-preview__icon-button">⟳</span>
          <span class="theme-preview__primary-action">+ Create</span>
        </div>

        <div class="theme-preview__table">
          <div class="theme-preview__table-head">
            @for (column of tableColumns; track column.label) {
              <span class="theme-preview__th" [class.theme-preview__th--actions]="column.actions">
                {{ column.label }}
                @if (column.sortable) {
                  <span class="theme-preview__sort-icon">⇅</span>
                }
              </span>
            }
          </div>

          <div class="theme-preview__table-body">
            @for (row of rows; track row.label; let last = $last) {
              <div [class]="rowClass(row.state)" [class.theme-preview__row--last]="last">
                <span class="theme-preview__td theme-preview__td--name">
                  <span class="theme-preview__row-dot"></span>
                  <span class="theme-preview__row-label">{{ row.label }}</span>
                </span>
                <span class="theme-preview__td theme-preview__td--muted">{{ row.type }}</span>
                <span class="theme-preview__td">
                  <span [class]="statusClass(row.status)">{{ row.status }}</span>
                </span>
                <span class="theme-preview__td theme-preview__td--actions">
                  <span class="theme-preview__action-icon"></span>
                  <span class="theme-preview__action-icon"></span>
                </span>
              </div>
            }
          </div>

          <div class="theme-preview__pagination">
            <span class="theme-preview__page-report">1 - {{ rows.length }} / {{ rows.length }}</span>
            <span class="theme-preview__pager">
              <span class="theme-preview__pager-arrow">«</span>
              <span class="theme-preview__pager-arrow">‹</span>
              <span class="theme-preview__pager-page theme-preview__pager-page--active">1</span>
              <span class="theme-preview__pager-arrow">›</span>
              <span class="theme-preview__pager-arrow">»</span>
            </span>
            <span class="theme-preview__select">25 <span class="theme-preview__chevron"></span></span>
          </div>
        </div>
      } @else {
        <div class="theme-preview__toolbar">
          <span class="theme-preview__heading">Customers</span>
          <span class="theme-preview__spacer"></span>
          <span class="theme-preview__secondary-action">Filter</span>
          <span class="theme-preview__primary-action">+ New</span>
        </div>

        <div class="theme-preview__list">
          @for (row of rows.slice(0, rowLimit()); track row.label; let last = $last) {
            <div [class]="rowClass(row.state)" [class.theme-preview__row--last]="last">
              <span class="theme-preview__row-dot"></span>
              <span class="theme-preview__row-label">{{ row.label }}</span>
              @if (showLabels()) {
                <span [class]="statusClass(row.status)">{{ row.status }}</span>
              }
            </div>
          }
        </div>
      }
    </section>
  </main>
  }
</div>
